import { message } from 'antd';

import { http } from './http';
import { unwrapData } from '../utils/unwrapApiData';
import { downloadBlob, reportBulkResult } from '../utils/bulkActionFeedback';
import { getApiErrorMessage } from '../utils/apiError';

/**
 * فراخوانی bulk که ممکن است JSON یا فایل (csv/zip) برگرداند.
 * @param {string} url
 * @param {object} body
 * @param {import('axios').AxiosRequestConfig} [config]
 */
async function parseBlobError(error) {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const json = JSON.parse(await data.text());
      error.response.data = json;
      if (json?.message) error.message = json.message;
    } catch {
      /* ignore */
    }
  }
  return error;
}

export async function postBulkAction(url, body, config = {}) {
  let response;
  try {
    response = await http.post(url, body, {
      ...config,
      responseType: 'blob',
      transformResponse: [(data) => data],
    });
  } catch (error) {
    throw await parseBlobError(error);
  }

  const contentType = String(response.headers?.['content-type'] || '');
  if (contentType.includes('application/json') || contentType.includes('text/json')) {
    const text = await response.data.text();
    const json = JSON.parse(text);
    return { type: 'json', data: unwrapData(json) ?? json };
  }

  if (contentType.includes('text/csv') || contentType.includes('application/zip') || contentType.includes('octet-stream')) {
    const disposition = String(response.headers?.['content-disposition'] || '');
    const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
    const filename = match ? decodeURIComponent(match[1].replace(/"/g, '')) : 'export.bin';
    return { type: 'file', blob: response.data, filename };
  }

  try {
    const text = await response.data.text();
    const json = JSON.parse(text);
    return { type: 'json', data: unwrapData(json) ?? json };
  } catch {
    return { type: 'file', blob: response.data, filename: 'export.bin' };
  }
}

export async function applyBulkResponse(result, { successLabel } = {}) {
  if (result?.type === 'file') {
    downloadBlob(result.blob, result.filename || 'export.bin');
    message.success('خروجی آماده شد.');
    return result;
  }
  reportBulkResult(result?.data, { successLabel });
  return result;
}

export async function runBulkAction(url, body, { successLabel, config } = {}) {
  try {
    const result = await postBulkAction(url, body, config);
    await applyBulkResponse(result, { successLabel });
    return result;
  } catch (error) {
    message.error(getApiErrorMessage(error, 'عملیات گروهی ناموفق بود.'));
    throw error;
  }
}
